var _circle, _path, _path2, _rect, _rect2, _rect3, _rect4, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisaOthers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 70,
    r: 70,
    fill: "#325AFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.466 103.978c-4.473-4.417-27.819-26.562-27.819-26.562-8.966-8.91-11.567-19.616-2.35-29.923 9.216-10.307 23.533-8.877 32.502.03.134.13.296.291.431.428l.764.759.45.447c6.433 6.388 9.569 9.505 15.527 15.424.893.886.673 2.266-.3 3.065-4.27 3.502-9.45 2.262-17.314-3.736",
    fill: "#CFD9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.648 86.21a4.696 4.696 0 00.839 5.998 4.566 4.566 0 005.066.696c.049.092.102.183.16.273a4.693 4.693 0 001.404 4.703c3.49 3.114 12.476 0 20.26-5.617 4.922-4.772 11.835-11.498 15.569-15.232 6.211-6.211 14.426-21.125.858-32.431-13.568-11.307-27.03-.614-32.896 4.907l15.01 15.529c.346.517.519 1.863-1.552 3.106-2.588 1.553-5.694 2.588-16.046-4.659-4.719 5.095-9.387 10.14-13.942 15.364a4.693 4.693 0 00.412 6.57 4.566 4.566 0 004.858.793z",
    fill: "#0022AE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 59.653,
    y: 98.004,
    width: 9.317,
    height: 18.077,
    rx: 4.659,
    transform: "rotate(-43.806 59.653 98.004)",
    fill: "#E4E9FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 66.9,
    y: 92.828,
    width: 9.317,
    height: 18.077,
    rx: 4.659,
    transform: "rotate(-43.806 66.9 92.828)",
    fill: "#E4E9FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 73.111,
    y: 86.617,
    width: 9.317,
    height: 18.077,
    rx: 4.659,
    transform: "rotate(-43.806 73.111 86.617)",
    fill: "#E4E9FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 79.323,
    y: 80.405,
    width: 9.317,
    height: 18.077,
    rx: 4.659,
    transform: "rotate(-43.806 79.323 80.405)",
    fill: "#E4E9FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.016 65.672c-2.07 3.105-4.866 5.487-9.835 2.588-4.97-2.899-7.568-4.897-7.568-4.897-1.983 1.712-8.129 3.364-13.243 0",
    stroke: "#325AFF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.612 83.433l11.534-12.999M67.216 89.915L79.258 76.09",
    stroke: "#CFD8FF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.006 95.696l5.694 6.211M76.735 89.915l5.694 6.211M83.507 83.703l5.694 6.212",
    stroke: "#325AFF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
export default SvgVisaOthers;